.discord-replied-message {
	color: #b9bbbe;
	display: flex;
	font-size: 0.875rem;
	font-family: Whitney, 'Source Sans Pro', ui-sans-serif, system-ui, -apple-system, 'system-ui', 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
		sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';

	padding-top: 2px;
	margin-left: 56px;
	margin-bottom: 4px;
	align-items: center;
	line-height: 1.125rem;
	position: relative;
	white-space: pre;
	user-select: none;
}

.discord-light-theme .discord-replied-message {
	color: #4f5660;
}

.discord-compact-mode .discord-replied-message {
	margin-left: 62px;
	margin-bottom: 0;
}

.discord-replied-message:before {
	content: '';
	display: block;
	position: absolute;
	top: 50%;
	right: 100%;
	bottom: 0;
	left: -36px;
	margin-right: 4px;
	margin-top: -1px;
	margin-left: -1px;
	margin-bottom: -2px;
	border-left: 2px solid #4f545c;
	border-bottom: 0 solid #4f545c;
	border-right: 0 solid #4f545c;
	border-top: 2px solid #4f545c;
	border-top-left-radius: 6px;
}

.discord-light-theme .discord-replied-message:before {
	border-color: #747f8d;
}

.discord-replied-message .discord-replied-message-avatar,
.discord-replied-message .discord-reply-badge {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 auto;
	flex: 0 0 auto;
	width: 16px;
	height: 16px;
	border-radius: 50%;
	user-select: none;
	margin-right: 0.25rem;
}

.discord-replied-message .discord-reply-badge {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #b9bbbe;
	background: #202225;
}

.discord-light-theme .discord-replied-message .discord-reply-badge {
	color: #4f5660;
	background: #e3e5e8;
}

.discord-replied-message .discord-application-tag {
	background-color: hsl(235, 85.6%, 64.7%);
	color: #fff;
	font-size: 0.625rem;
	margin-right: 0.25rem;
	line-height: 100%;
	text-transform: uppercase;
	/* Use flex layout to ensure both verified icon and "BOT" text are aligned to center */
	display: flex;
	align-items: center;
	/* Styling taken through Inspect Element on Discord client for Windows */
	height: 0.9375rem;
	padding: 0 0.275rem;
	margin-top: 0.075em;
	border-radius: 0.1875rem;
}

.discord-replied-message .discord-application-tag .discord-application-tag-verified {
	width: 0.9375rem;
	height: 0.9375rem;
	margin-left: -0.1rem;
}

.discord-replied-message .discord-application-tag.discord-application-tag-op {
	background-color: #c9cdfb;
	color: #4752c4;
	border-radius: 0.4rem;
}

.discord-replied-message .discord-replied-message-username {
	flex-shrink: 0;
	font-size: inherit;
	line-height: inherit;
	margin-right: 0.25rem;
	opacity: 0.64;
	font-weight: 500;
	color: #fff;
}

.discord-replied-message .discord-replied-message-content {
	color: inherit;
	font-size: inherit;
	line-height: inherit;
	white-space: pre;
	text-overflow: ellipsis;
	user-select: none;
	cursor: pointer;
	overflow-x: hidden;
}

.discord-replied-message .discord-replied-message-content:hover {
	color: #fff;
}

.discord-light-theme .discord-replied-message .discord-replied-message-content:hover {
	color: #000;
}

.discord-replied-message .discord-replied-message-content .discord-message-edited {
	margin-left: 0.25rem;
}

.discord-replied-message .discord-replied-message-content-icon {
	-webkit-box-flex: 0;
	-ms-flex: 0 0 auto;
	flex: 0 0 auto;
	width: 20px;
	height: 20px;
	margin-left: 4px;
}

@import '../author-info/author-info.css';
